module.exports = __webpack_public_path__ + "static/img/elc.65a616a4.png";